import Vue from 'vue'
import VueI18n from 'vue-i18n'
import lang from '../lang/dist'

Vue.use(VueI18n)

const fallbackLocale = 'en'

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale,
  messages: lang,
})

const loadedLanguages = Object.keys(lang)

const setI18nLanguage = (language: string): string => {
  i18n.locale = language
  document.querySelector('html').setAttribute('lang', language)
  return language
}

export const loadLanguageAsync = (language: string): Promise<string> => {

  // if matches locale in format en-gb, then fallback to en
  // if matches locale in format it-gb, then fallback to it
  // if no translation available, fallback to en
  const locale = language.split('-')[0]

  if (i18n.locale === locale) {
    return Promise.resolve(locale)
  }

  if (loadedLanguages.includes(locale)) {
    return Promise.resolve(setI18nLanguage(locale))
  }

  return Promise.resolve(setI18nLanguage(fallbackLocale))
}

export const useI18n = () => {

  return {
    t: i18n.t.bind(i18n),
    te: i18n.te.bind(i18n),
    tc: i18n.tc.bind(i18n),
    d: i18n.d.bind(i18n),
    n: i18n.n.bind(i18n),
    locale: i18n.locale,
  }

}
